<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon class="m-2" icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon class="m-2" icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div *ngIf="action === 'edit'" i18n>Editing Survey: {{ survey.survey_id }}</div>
        <div *ngIf="action === 'clone'" i18n>Cloning Survey</div>
        <div *ngIf="action === 'create'" i18n>Creating Survey</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 700px">
    <form [formGroup]="surveyForm">
      <div class="row">
        <div class="col">
          <div class="field-label" i18n>Survey ID<span style="color: red">*</span></div>
          <input class="w-100" nbInput formControlName="survey_id" />
          <div *ngIf="surveyForm.get('survey_id').hasError('pattern')">
            <div class="error" i18n>ID allows alphanumeric characters, underscore and colon.</div>
          </div>
        </div>
        <div class="col">
          <div class="field-label" i18n>Survey Name<span style="color: red">*</span></div>
          <input class="w-100" nbInput formControlName="survey_name" />
        </div>
      </div>

      <div formArrayName="questions">
        <app-survey-questions
          *ngFor="let question of questions().controls; let qi = index"
          [group]="question"
          [qi]="qi"
          (addAnswer)="addAnswer(qi)"
          (addAction)="addAction(qi, $event.ai)"
          (removeQuestion)="removeQuestion(qi)"
          (removeAnswer)="removeAnswer(qi, $event.ai)"
          (removeAction)="removeAction(qi, $event.ai, $event.aci)"
        ></app-survey-questions>
      </div>

      <button class="mt-3" nbButton size="small" status="success" (click)="addQuestion()" i18n>
        <nb-icon icon="plus-square-outline"></nb-icon> New Question
      </button>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton class="ml-3" status="success" (click)="onSubmit()" [disabled]="!surveyForm.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
